export * from './ProductDetailsCardCarousel';
